import React, { Component } from 'react';
import { connect } from 'react-redux';
import logo from '../images/logo.svg';

class NA extends Component {

  render() {
    return (
      <div className='container-middle'>
        <div className='content-middle text-center pl-3 pr-3'>
          <h1>404</h1>
          <img src={logo} className="logo" alt="logo" />
          <p className='description'>page <span className='highlight'>{document.URL}</span> does not exist</p>
        </div>
      </div>
    );
  }
}

const mapStateToProps = state => ({

});

export default connect(mapStateToProps)(NA);